module.exports = __webpack_public_path__ + "assets/img/247601.922fcb25.png";